<template>
  <div class="app-container">
    <div>
      <el-row>
        <el-col :span="2">&nbsp;</el-col>
        <el-col :span="20">
          <el-form :inline="true" label-position="top" label-width="100px" class="custom-form">
            <el-form-item :label="$t('station.stationName')" class="custom-item">
              <el-select
                :placeholder="$t('company.station')"
                v-model="reportFilter.stationId"
                class="filter-item"
              >
                <el-option v-if="isAllStation === 1" label="全部" value />
                <el-option
                  v-for="(item,index) in stationList"
                  :key="index"
                  :label="item.stationName"
                  :value="item.stationId"
                />
              </el-select>
            </el-form-item>
            <!--            <el-form-item :label="$t('record.shiftNo')" class="custom-item">
              <el-input
                :placeholder="$t('record.shiftNo')"
                v-model="reportFilter.shiftNo"
                class="filter-item"
              />
            </el-form-item>-->
            <el-form-item :label="$t('seting.empName')" class="custom-item">
              <el-input
                :placeholder="$t('seting.empName')"
                v-model="reportFilter.empName"
                class="filter-item"
              />
            </el-form-item>
            <el-form-item label="日期选择" class="custom-item">
              <el-date-picker
                v-model="timeRange"
                :default-time="['00:00:00','23:59:59']"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
            <el-form-item label="报表类型" class="custom-item">
              <el-select v-model="reportType" placeholder="请选择报表类型">
                <el-option
                  v-for="(item,index) in reportTypes"
                  :key="index"
                  :label="item.type"
                  :value="item.order"
                />
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="2">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col>&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col :span="11">&nbsp;</el-col>
        <el-col :span="2">
          <el-button type="primary" @click="getReportData">查询</el-button>
        </el-col>
        <el-col :span="11">&nbsp;</el-col>
      </el-row>
    </div>
    <el-table :data="recordList" border fit highlight-current-row style="width: 100%">
      <!--      <el-table-column
        prop="shiftNo"
        align="center"
        label="日次号"
        width="140px"
      />-->
      <el-table-column prop="stationName" align="center" label="站点名" />
      <el-table-column prop="empName" align="center" label="员工名" />
      <el-table-column prop="startTime" align="center" label="开始时间" min-width="170px" />
      <el-table-column prop="endTime" align="center" label="结束时间" min-width="170px" />
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button
            type="info"
            icon="el-icon-printer"
            size="medium"
            @click="handlePrint(scope.row)"
          >打印</el-button>
        </template>
        <!--<template v-if="false" slot-scope="scope">-->
        <!--<el-col>-->
        <!--<el-row>-->
        <!--<el-button size="mini" plain @click="handleGetFuelCardInfo(scope.row)">油品-卡类型</el-button>-->
        <!--<el-button size="mini" plain @click="handleGetFpOrderInfo(scope.row)">油枪销售</el-button>-->
        <!--<el-button size="mini" plain @click="handleGetRechargePaidInfo(scope.row)">班次充值</el-button>-->
        <!--<el-button size="mini" plain @click="handleGetUserPaidInfo(scope.row)">加油-支付方式</el-button>-->
        <!--</el-row>-->
        <!--</el-col>-->
        <!--</template>-->
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        :current-page="reportFilter.pi"
        :page-sizes="[10,20,30, 50]"
        :page-size="reportFilter.ps"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="handleClose"
      title="数据查询-日报表"
      width="1000px"
    >
      <!--*********************班次-卡类型***************************-->
      <div ref="tableCardTypeOutter" style="width: 100%;">
        <div v-if="cardTypeFlag" ref="tableCardType">
          <h3 style="text-align:center;">油品-卡类型汇总</h3>
          <table class="table-info">
            <tr>
              <td style="text-align: left">
                <a>站点:{{ shiftCardFuelData.stationName }}</a>
              </td>
              <td style="text-align: right">
                <a>开始:{{ shiftCardFuelData.startTime }}</a>
              </td>
            </tr>
            <tr>
              <td style="text-align: left">
                <a>日次号:{{ shiftCardFuelData.shiftNo }}</a>
              </td>
              <td style="text-align: right">
                <a>结束:{{ shiftCardFuelData.endTime }}</a>
              </td>
            </tr>
          </table>
          <table style="width: 100%;height: auto;" border="1px" cellspacing="0" cellpadding="0">
            <thead align="center" valign="middle">
              <tr class="tableHead">
                <th>油品</th>
                <th>卡类型</th>
                <th>笔数</th>
                <th>加出升数</th>
                <th>加出金额</th>
              </tr>
            </thead>
            <tbody class="tbody">
              <tr v-for="(item, index) in shiftCardFuelList" :key="index" style="height: 40px">
                <template v-if="item.subtotal">
                  <td class="tfoot">
                    <strong>{{ item.prodName }}</strong>
                  </td>
                  <td class="tfoot">
                    <strong>{{ item.cnt }}</strong>
                  </td>
                  <td class="tfoot">
                    <strong>{{ item.totalVol / 100 }}</strong>
                  </td>
                  <td class="tfoot">
                    <strong>{{ item.totalMoney / 100 }}</strong>
                  </td>
                </template>
                <template v-else>
                  <template v-if="item.totalSpan">
                    <td :rowspan="item.totalSpan + 1">{{ item.prodName }}</td>
                  </template>
                  <td>{{ item.type | cardTypeFilter }}</td>
                  <td>{{ item.cnt }}</td>
                  <td>{{ item.vol }}</td>
                  <td>{{ item.receAmt }}</td>
                </template>
              </tr>
            </tbody>
            <tfoot class="tfoot" style="text-align: center;height: auto">
              <tr>
                <td colspan="2" style="height: 40px">
                  <strong>总计：</strong>
                </td>
                <td>
                  <strong>{{ shiftCardFuelData.cnts }}</strong>
                </td>
                <td>
                  <strong>{{ shiftCardFuelData.totalVol }}</strong>
                </td>
                <td>
                  <strong>{{ shiftCardFuelData.totalAmt }}</strong>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <!--*********************班次-油枪销售***************************-->
      <div ref="tableFpOrderOutter">
        <div v-if="fpOrderFlag" ref="tableFpOrder">
          <h3 style="text-align:center;">油枪-油品汇总</h3>
          <table class="table-info">
            <tr>
              <td style="text-align: left">
                <a>站点:{{ shiftFpOrderData.stationName }}</a>
              </td>
              <td style="text-align: right">
                <a>开始:{{ shiftFpOrderData.startTime }}</a>
              </td>
            </tr>
            <tr>
              <td style="text-align: left">
                <a>日次:{{ shiftFpOrderData.shiftNo }}</a>
              </td>
              <td style="text-align: right">
                <a>结束:{{ shiftFpOrderData.endTime }}</a>
              </td>
            </tr>
          </table>
          <div>
            <table style="width: 100%;height: auto;" border="1px" cellspacing="0" cellpadding="0">
              <thead align="center" valign="middle">
                <tr class="tableHead">
                  <th>油品</th>
                  <th>油枪</th>
                  <th>销售升数</th>
                  <th>销售金额</th>
                  <th>实收金额</th>
                  <th>优惠金额</th>
                  <th>开始金额</th>
                  <th>结束金额</th>
                  <th>开始升数</th>
                  <th>结束升数</th>
                </tr>
              </thead>
              <tbody class="tbody">
                <tr v-for="(item, index) in shiftFpOrderList" :key="index" style="height: 40px">
                  <template v-if="item.subtotal" class="tfoot">
                    <td class="tfoot">
                      <strong>{{ item.prodName }}</strong>
                    </td>
                    <td class="tfoot">
                      <strong>{{ item.totalVol / 100 }}</strong>
                    </td>
                    <td class="tfoot">
                      <strong>{{ item.totalReceAmt / 100 }}</strong>
                    </td>
                    <td class="tfoot">
                      <strong>{{ item.totalRealAmt / 100 }}</strong>
                    </td>
                    <td class="tfoot">
                      <strong>{{ item.totalDiscAmt / 100 }}</strong>
                    </td>
                    <td class="tfoot">
                      <strong>---</strong>
                    </td>
                    <td class="tfoot">
                      <strong>---</strong>
                    </td>
                    <td class="tfoot">
                      <strong>---</strong>
                    </td>
                    <td class="tfoot">
                      <strong>---</strong>
                    </td>
                  </template>
                  <template v-else>
                    <template v-if="item.totalSpan">
                      <td :rowspan="item.totalSpan + 1">{{ item.prodName }}</td>
                    </template>
                    <td>{{ item.fpNo }}</td>
                    <td>{{ item.vol }}</td>
                    <td>{{ item.receAmt }}</td>
                    <td>{{ item.realAmt }}</td>
                    <td>{{ item.discAmt }}</td>
                    <td>{{ item.totalStartAmt }}</td>
                    <td>{{ item.totalEndAmt }}</td>
                    <td>{{ item.totalStartVol }}</td>
                    <td>{{ item.totalEndVol }}</td>
                  </template>
                </tr>
              </tbody>
              <tfoot class="tfoot" style="text-align: center;height: auto">
                <tr>
                  <td colspan="2" style="height: 40px">
                    <strong>总计：</strong>
                  </td>
                  <td>
                    <strong>{{ shiftFpOrderData.totalVol }}</strong>
                  </td>
                  <td>
                    <strong>{{ shiftFpOrderData.totalReceAmt }}</strong>
                  </td>
                  <td>
                    <strong>{{ shiftFpOrderData.totalRealAmt }}</strong>
                  </td>
                  <td>
                    <strong>{{ shiftFpOrderData.totalDiscAmt }}</strong>
                  </td>
                  <td>
                    <strong>---</strong>
                  </td>
                  <td>
                    <strong>---</strong>
                  </td>
                  <td>
                    <strong>---</strong>
                  </td>
                  <td>
                    <strong>---</strong>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <!--*********************班次-支付方式***************************-->
      <div ref="tableUserPaidOutter">
        <div v-if="userPaidFlag" ref="tableUserPaid">
          <h3 style="text-align:center;">员工加油-支付方式汇总</h3>
          <table class="table-info">
            <tr>
              <td style="text-align: left">
                <a>站点:{{ shiftUserPaidData.stationName }}</a>
              </td>
              <td style="text-align: right">
                <a>开始:{{ shiftUserPaidData.startTime }}</a>
              </td>
            </tr>
            <tr>
              <td style="text-align: left">
                <a>日次:{{ shiftUserPaidData.shiftNo }}</a>
              </td>
              <td style="text-align: right">
                <a>结束:{{ shiftUserPaidData.endTime }}</a>
              </td>
            </tr>
          </table>
          <div>
            <table style="width: 100%;height: auto;" border="1px" cellspacing="0" cellpadding="0">
              <thead align="center" valign="middle">
                <tr class="tableHead">
                  <th>姓名</th>
                  <th>支付方式</th>
                  <th>笔数</th>
                  <th>升数</th>
                  <th>销售金额</th>
                  <th>实收金额</th>
                </tr>
              </thead>
              <tbody class="tbody">
                <tr v-for="(item, index) in shiftUserPaidList" :key="index" style="height: 40px">
                  <template v-if="item.subtotal" class="tfoot">
                    <td class="tfoot">
                      <strong>{{ item.empName }}</strong>
                    </td>
                    <td class="tfoot">
                      <strong>{{ item.totalCnt }}</strong>
                    </td>
                    <td class="tfoot">
                      <strong>{{ item.totalVol / 100 }}</strong>
                    </td>
                    <td class="tfoot">
                      <strong>{{ item.totalReceAmt / 100 }}</strong>
                    </td>
                    <td class="tfoot">
                      <strong>{{ item.totalRealAmt / 100 }}</strong>
                    </td>
                  </template>
                  <template v-else>
                    <template v-if="item.totalSpan">
                      <td :rowspan="item.totalSpan + 1">{{ item.empName }}</td>
                    </template>
                    <td>{{ item.payTypeName }}</td>
                    <td>{{ item.cnt }}</td>
                    <td>{{ item.vol }}</td>
                    <td>{{ item.receAmt }}</td>
                    <td>{{ item.realAmt }}</td>
                  </template>
                </tr>
              </tbody>
              <tfoot class="tfoot" style="text-align: center;height: auto">
                <tr>
                  <td colspan="2" style="height: 40px">
                    <strong>总计：</strong>
                  </td>
                  <td>
                    <strong>{{ shiftUserPaidData.totalCnt }}</strong>
                  </td>
                  <td>
                    <strong>{{ shiftUserPaidData.totalVol }}</strong>
                  </td>
                  <td>
                    <strong>{{ shiftUserPaidData.totalReceAmt }}</strong>
                  </td>
                  <td>
                    <strong>{{ shiftUserPaidData.totalRealAmt }}</strong>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <!--*********************班次-充值***************************-->
      <div ref="tableRechargePaidOutter">
        <div v-if="rechargePaidFlag" ref="tableRechargePaid">
          <h3 style="text-align:center;">日次-充值汇总</h3>
          <table class="table-info">
            <tr>
              <td style="text-align: left">
                <a>站点:{{ shiftRechargePaidData.stationName }}</a>
              </td>
              <td style="text-align: right">
                <a>开始:{{ shiftRechargePaidData.startTime }}</a>
              </td>
            </tr>
            <tr>
              <td style="text-align: left">
                <a>日次:{{ shiftRechargePaidData.shiftNo }}</a>
              </td>
              <td style="text-align: right">
                <a>结束:{{ shiftRechargePaidData.endTime }}</a>
              </td>
            </tr>
          </table>
          <div>
            <table style="width: 100%;height: auto;" border="1px" cellspacing="0" cellpadding="0">
              <thead align="center" valign="middle">
                <tr class="tableHead">
                  <th>姓名</th>
                  <th>支付方式</th>
                  <th>笔数</th>
                  <th>充值金额</th>
                  <th>赠送金额</th>
                </tr>
              </thead>
              <tbody class="tbody">
                <tr
                  v-for="(item, index) in shiftRechargePaidList"
                  :key="index"
                  style="height: 40px"
                >
                  <template v-if="item.subtotal" class="tfoot">
                    <td class="tfoot">
                      <strong>{{ item.empName }}</strong>
                    </td>
                    <td class="tfoot">
                      <strong>{{ item.totalCnt }}</strong>
                    </td>
                    <td class="tfoot">
                      <strong>{{ item.totalRecharge / 100 }}</strong>
                    </td>
                    <td class="tfoot">
                      <strong>{{ item.totalGiftAmt / 100 }}</strong>
                    </td>
                  </template>
                  <template v-else>
                    <template v-if="item.totalSpan">
                      <td :rowspan="item.totalSpan + 1">{{ item.empName }}</td>
                    </template>
                    <td>{{ item.payTypeName }}</td>
                    <td>{{ item.cnt }}</td>
                    <td>{{ item.amt }}</td>
                    <td>{{ item.giftAmt }}</td>
                  </template>
                </tr>
              </tbody>
              <tfoot class="tfoot" style="text-align: center;">
                <tr>
                  <td colspan="2" style="height: 40px">
                    <strong>总计：</strong>
                  </td>
                  <td>
                    <strong>{{ shiftRechargePaidData.totalCnt }}</strong>
                  </td>
                  <td>
                    <strong>{{ shiftRechargePaidData.totalRecharge }}</strong>
                  </td>
                  <td>
                    <strong>{{ shiftRechargePaidData.totalGiftAmt }}</strong>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div>
        <el-row>
          <el-col>&nbsp;</el-col>
        </el-row>
        <el-row v-if="printButton">
          <el-col :span="10">&nbsp;</el-col>
          <el-col :span="2">
            <el-button type="primary" @click="printForms">打印</el-button>
          </el-col>
          <el-col :span="2" :offset="1">
            <el-button type="primary" @click="handleClearActi">关 闭</el-button>
          </el-col>
          <el-col :span="10">&nbsp;</el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui'
import Print from '@/utils/print'
import Vue from 'vue'
import { getEmpInfo } from '@/utils/auth'
import { formatDateTime, getDateOfMonth } from '@/utils/index'
import { listStationSimple } from '@/api/station'
import {
  fetchShiftRecord,
  shiftCardFuel,
  shiftFpOrder,
  shiftRechargePaid,
  shiftUserPaid
} from '@/api/record'
Vue.use(Print) // 注册
const emp = getEmpInfo()
const cardTypeMap = { '-1': '脱机加油', '0': '员工', '1': '客户' }
export default {
  name: 'ReportFormOri',
  filters: {
    cardTypeFilter(type) {
      return cardTypeMap[type]
    }
  },
  data() {
    return {
      reportType: 0,
      reportTypes: [
        { order: 0, type: '油品-卡类型' },
        { order: 1, type: '油枪油品销售' },
        { order: 2, type: '日次充值' },
        { order: 3, type: '员工加油支付方式' }
      ], // 0 油品-卡类型 ，1 油枪销售 ，2 班次充值 ，3 加油支付方式
      dialogVisible: false,
      printButton: false,
      cardTypeFlag: false,
      rechargePaidFlag: false,
      userPaidFlag: false,
      fpOrderFlag: false,
      total: 1,
      tableRef: '',
      recordList: [],
      reportFilter: {
        type: 1,
        stationId:
          getEmpInfo().isAllStation === 0 ? getEmpInfo().stationId : '',
        shiftNo: '',
        empName: '',
        begin: '',
        end: '',
        pi: 1,
        ps: 20
      },
      isAllStation: getEmpInfo().isAllStation,
      timeRange: getDateOfMonth(0),
      stationList: [],
      group: emp.groupName,
      userName: emp.empName,
      now: formatDateTime(new Date(), 'yyyy/MM/dd hh:mm:ss'),
      shiftCardFuelData: {},
      shiftFpOrderData: {},
      shiftRechargePaidData: {},
      shiftUserPaidData: {},
      shiftCardFuelList: [],
      shiftFpOrderList: [],
      shiftRechargePaidList: [],
      shiftUserPaidList: []
    }
  },
  created() {
    listStationSimple({ ps: 100 }).then(response => {
      const row = response.data
      if (row.data.length) {
        this.stationList = row.data
        this.getReportData()
      }
    })
  },
  methods: {
    printForms() {
      this.$print(this.$refs[this.tableRef + 'Outter'])
      // window.print()
    },
    clearShiftTables() {
      this.shadowPrintButton()
      this.cardTypeFlag = false
      this.fpOrderFlag = false
      this.rechargePaidFlag = false
      this.userPaidFlag = false
    },
    getReportData() {
      if (!this.timeRange) {
        this.timeRange = []
      }
      if (this.timeRange[0]) {
        this.reportFilter.begin = this.timeRange[0]
      } else {
        this.reportFilter.begin = ''
      }
      if (this.timeRange[1]) {
        this.reportFilter.end = this.timeRange[1]
      } else {
        this.reportFilter.end = ''
      }
      fetchShiftRecord(this.reportFilter).then(resp => {
        this.recordList = resp.data.data.items
        this.total = resp.data.data.totalItems
      })
    },
    handleGetFuelCardInfo(row) {
      this.clearShiftTables()
      shiftCardFuel({ stationId: row.stationId, shiftNo: row.shiftNo }).then(
        resp => {
          if (resp.data.data) {
            this.shiftCardFuelData = resp.data.data
            this.handleCardTypeFuel(this.shiftCardFuelData.items)
          }
        }
      )
    },
    handleGetFpOrderInfo(row) {
      this.clearShiftTables()
      shiftFpOrder({ stationId: row.stationId, shiftNo: row.shiftNo }).then(
        resp => {
          if (resp.data.data) {
            this.shiftFpOrderData = resp.data.data
            this.handleFpOrder(this.shiftFpOrderData.items)
          }
        }
      )
    },
    handleGetRechargePaidInfo(row) {
      this.clearShiftTables()
      shiftRechargePaid({
        stationId: row.stationId,
        shiftNo: row.shiftNo
      }).then(resp => {
        if (resp.data.data) {
          this.shiftRechargePaidData = resp.data.data
          this.handleRechargePaid(this.shiftRechargePaidData.items)
        }
      })
    },
    handleGetUserPaidInfo(row) {
      this.clearShiftTables()
      shiftUserPaid({ stationId: row.stationId, shiftNo: row.shiftNo }).then(
        resp => {
          if (resp.data.data) {
            this.shiftUserPaidData = resp.data.data
            this.handleUserPaid(this.shiftUserPaidData.items)
          }
        }
      )
    },
    handleCardTypeFuel(items) {
      this.shiftCardFuelList = []
      if (!items || !items.length) {
        MessageBox.alert('没有该日的该报表类型信息！', '提示')
        return
      }
      const prodMap = {}
      if (items.length === 1) {
        prodMap[items[0].prodName] = {
          salesNum: items[0].cnt,
          totalVol: items[0].vol * 100,
          totalMoney: items[0].realAmt * 100,
          totalSpan: 1,
          firstIndex: 0
        }
      } else {
        for (let i = 0; i < items.length; i++) {
          if (!prodMap[items[i].prodName]) {
            prodMap[items[i].prodName] = {
              salesNum: items[i].cnt,
              totalVol: items[i].vol * 100,
              totalMoney: items[i].realAmt * 100,
              totalSpan: 1,
              firstIndex: i
            }
          } else {
            prodMap[items[i].prodName] = {
              salesNum: items[i].cnt + prodMap[items[i].prodName].salesNum,
              totalVol:
                items[i].vol * 100 + prodMap[items[i].prodName].totalVol,
              totalMoney:
                items[i].realAmt * 100 + prodMap[items[i].prodName].totalMoney,
              totalSpan: prodMap[items[i].prodName].totalSpan + 1,
              firstIndex: prodMap[items[i].prodName].firstIndex
            }
          }
        }
      }

      // 处理数据：添加小计，合并
      let varIndex = 0
      const formatArr = items.slice()
      for (const key in prodMap) {
        formatArr[prodMap[key].firstIndex + varIndex].totalSpan =
          prodMap[key].totalSpan
        const newIndex =
          prodMap[key].firstIndex + varIndex + prodMap[key].totalSpan
        const miniTotal = {
          subtotal: 1,
          prodName: '小计',
          totalVol: prodMap[key].totalVol,
          totalMoney: prodMap[key].totalMoney,
          cnt: prodMap[key].salesNum
        }
        formatArr.splice(newIndex, 0, miniTotal)
        varIndex++
      }
      this.shiftCardFuelList = formatArr
      this.cardTypeFlag = true
      this.showPrintButton('tableCardType')
      this.handleDialogShow()
    },
    handleFpOrder(items) {
      if (!items || !items.length) {
        MessageBox.alert('没有该日的该报表类型信息！', '提示')
        return
      }
      const fpOrderMap = {}
      if (items.length === 1) {
        fpOrderMap[items[0].prodName] = {
          totalVol: items[0].vol * 100,
          totalReceAmt: items[0].receAmt * 100,
          totalRealAmt: items[0].realAmt * 100,
          totalDiscAmt: items[0].discAmt * 100,
          totalSpan: 1,
          firstIndex: 0
        }
      } else {
        for (let i = 0; i < items.length; i++) {
          if (!fpOrderMap[items[i].prodName]) {
            fpOrderMap[items[i].prodName] = {
              totalVol: items[i].vol * 100,
              totalReceAmt: items[i].receAmt * 100,
              totalRealAmt: items[i].realAmt * 100,
              totalDiscAmt: items[i].discAmt * 100,
              totalSpan: 1,
              firstIndex: i
            }
          } else {
            fpOrderMap[items[i].prodName] = {
              totalVol:
                items[i].vol * 100 + fpOrderMap[items[i].prodName].totalVol,
              totalReceAmt:
                items[i].receAmt * 100 +
                fpOrderMap[items[i].prodName].totalReceAmt,
              totalRealAmt:
                items[i].realAmt * 100 +
                fpOrderMap[items[i].prodName].totalRealAmt,
              totalDiscAmt:
                items[i].discAmt * 100 +
                fpOrderMap[items[i].prodName].totalDiscAmt,
              totalSpan: fpOrderMap[items[i].prodName].totalSpan + 1,
              firstIndex: fpOrderMap[items[i].prodName].firstIndex
            }
          }
        }
      }
      // 处理数据：添加小计，合并
      let varIndex = 0
      const formatArr = items.slice()
      for (const key in fpOrderMap) {
        formatArr[fpOrderMap[key].firstIndex + varIndex].totalSpan =
          fpOrderMap[key].totalSpan
        const newIndex =
          fpOrderMap[key].firstIndex + varIndex + fpOrderMap[key].totalSpan
        const miniTotal = {
          subtotal: 1,
          prodName: '小计',
          totalVol: fpOrderMap[key].totalVol,
          totalRealAmt: fpOrderMap[key].totalRealAmt,
          totalReceAmt: fpOrderMap[key].totalReceAmt,
          totalDiscAmt: fpOrderMap[key].totalDiscAmt
        }
        formatArr.splice(newIndex, 0, miniTotal)
        varIndex++
      }
      this.shiftFpOrderList = formatArr
      this.fpOrderFlag = true
      this.showPrintButton('tableFpOrder')
      this.handleDialogShow()
    },
    handleUserPaid(items) {
      if (!items || !items.length) {
        MessageBox.alert('没有该日的该报表类型信息！', '提示')
        return
      }
      const userPaidMap = {}
      if (items.length === 1) {
        userPaidMap[items[0].empName] = {
          totalCnt: items[0].cnt,
          totalVol: items[0].vol * 100,
          totalReceAmt: items[0].receAmt * 100,
          totalRealAmt: items[0].realAmt * 100,
          totalSpan: 1,
          firstIndex: 0
        }
      } else {
        for (let i = 0; i < items.length; i++) {
          if (!userPaidMap[items[i].empName]) {
            userPaidMap[items[i].empName] = {
              totalCnt: items[i].cnt,
              totalVol: items[i].vol * 100,
              totalReceAmt: items[i].receAmt * 100,
              totalRealAmt: items[i].realAmt * 100,
              totalSpan: 1,
              firstIndex: i
            }
          } else {
            userPaidMap[items[i].empName] = {
              totalCnt: items[i].cnt + userPaidMap[items[i].empName].totalCnt,
              totalVol:
                items[i].vol * 100 + userPaidMap[items[i].empName].totalVol,
              totalReceAmt:
                items[i].receAmt * 100 +
                userPaidMap[items[i].empName].totalReceAmt,
              totalRealAmt:
                items[i].realAmt * 100 +
                userPaidMap[items[i].empName].totalRealAmt,
              totalSpan: userPaidMap[items[i].empName].totalSpan + 1,
              firstIndex: userPaidMap[items[i].empName].firstIndex
            }
          }
        }
      }
      // 处理数据：添加小计，合并
      let varIndex = 0
      const formatArr = items.slice()
      for (const key in userPaidMap) {
        formatArr[userPaidMap[key].firstIndex + varIndex].totalSpan =
          userPaidMap[key].totalSpan
        const newIndex =
          userPaidMap[key].firstIndex + varIndex + userPaidMap[key].totalSpan
        const miniTotal = {
          subtotal: 1,
          empName: '小计',
          totalCnt: userPaidMap[key].totalCnt,
          totalVol: userPaidMap[key].totalVol,
          totalRealAmt: userPaidMap[key].totalRealAmt,
          totalReceAmt: userPaidMap[key].totalReceAmt
        }
        formatArr.splice(newIndex, 0, miniTotal)
        varIndex++
      }
      this.shiftUserPaidList = formatArr
      this.userPaidFlag = true
      this.showPrintButton('tableUserPaid')
      this.handleDialogShow()
    },
    handleRechargePaid(items) {
      if (!items || !items.length) {
        MessageBox.alert('没有该日的该报表类型信息！', '提示')
        return
      }
      const rechargePaidMap = {}
      if (items.length === 1) {
        rechargePaidMap[items[0].empName] = {
          totalCnt: items[0].cnt,
          totalRecharge: items[0].amt * 100,
          totalGiftAmt: items[0].giftAmt * 100,
          totalSpan: 1,
          firstIndex: 0
        }
      } else {
        for (let i = 0; i < items.length; i++) {
          if (!rechargePaidMap[items[i].empName]) {
            rechargePaidMap[items[i].empName] = {
              totalCnt: items[i].cnt,
              totalRecharge: items[0].amt * 100,
              totalGiftAmt: items[0].giftAmt * 100,
              totalSpan: 1,
              firstIndex: i
            }
          } else {
            rechargePaidMap[items[i].empName] = {
              totalCnt:
                items[i].cnt + rechargePaidMap[items[i].empName].totalCnt,
              totalRecharge:
                items[i].amt * 100 +
                rechargePaidMap[items[i].empName].totalRecharge,
              totalGiftAmt:
                items[i].giftAmt * 100 +
                rechargePaidMap[items[i].empName].totalGiftAmt,
              totalSpan: rechargePaidMap[items[i].empName].totalSpan + 1,
              firstIndex: rechargePaidMap[items[i].empName].firstIndex
            }
          }
        }
      }
      // 处理数据：添加小计，合并
      let varIndex = 0
      const formatArr = items.slice()
      for (const key in rechargePaidMap) {
        formatArr[rechargePaidMap[key].firstIndex + varIndex].totalSpan =
          rechargePaidMap[key].totalSpan
        const newIndex =
          rechargePaidMap[key].firstIndex +
          varIndex +
          rechargePaidMap[key].totalSpan
        const miniTotal = {
          subtotal: 1,
          empName: '小计',
          totalCnt: rechargePaidMap[key].totalCnt,
          totalRecharge: rechargePaidMap[key].totalRecharge,
          totalGiftAmt: rechargePaidMap[key].totalGiftAmt
        }
        formatArr.splice(newIndex, 0, miniTotal)
        varIndex++
      }
      this.shiftRechargePaidList = formatArr
      this.rechargePaidFlag = true
      this.showPrintButton('tableRechargePaid')
      this.handleDialogShow()
    },
    handleSizeChange(val) {
      this.reportFilter.ps = val
      this.getReportData()
    },
    handleCurrentChange(val) {
      this.reportFilter.pi = val
      this.getReportData()
    },
    shadowPrintButton() {
      this.printButton = false
    },
    showPrintButton(ref) {
      this.tableRef = ref
      this.printButton = true
    },
    handleDialogShow() {
      if (
        this.cardTypeFlag ||
        this.fpOrderFlag ||
        this.rechargePaidFlag ||
        this.userPaidFlag
      ) {
        this.dialogVisible = true
      } else {
        this.dialogVisible = false
      }
    },
    handleClearActi() {
      this.printButton = false
      this.cardTypeFlag = false
      this.rechargePaidFlag = false
      this.userPaidFlag = false
      this.fpOrderFlag = false
      this.dialogVisible = false
    },
    handleClose(done) {
      this.handleClearActi()
      done()
    },
    handlePrint(row) {
      console.log(this.reportType)
      switch (this.reportType) {
        case 0:
          this.handleGetFuelCardInfo(row)
          break
        case 1:
          this.handleGetFpOrderInfo(row)
          break
        case 2:
          this.handleGetRechargePaidInfo(row)
          break
        case 3:
          this.handleGetUserPaidInfo(row)
          break
        default:
          this.$alert('没有该类型的报表', '提示', {
            confirmButtonText: '确定'
          })
      }
    }
  }
}
</script>

<style scoped>
table {
  width: 100%;
  /*border: black 1px solid;*/
}
.tableHead {
  font-size: 16px;
  height: 40px;
  font-family: '宋体';
}
.shiftNo {
  font-size: 26px;
}
.tfoot {
  height: 40px;
  font-size: 14px;
  text-align: center;
  font-family: '黑体';
}
.tbody {
  text-align: center;
  font-size: 14px;
  font-family: '宋体';
}
.table-info {
  text-align: center;
  border: 0px;
  font-size: 12px;
  font-family: '宋体';
}
</style>
